import ItemAlternative from "./item-alternative";

export default ItemAlternative;